export const devConfigs = {
    serverUrl: process.env.REACT_APP_DEV_SERVER_URL
}